import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { all_routes } from '../../core/data/routes/all_routes';
const Home = lazy(() => import('../frontend/HomePreview/HomePreview'));
import Services from '../frontend/services/services';
// import Booking from '../frontend/Booking/Booking';
import ProviderRegistration from '../frontend/auth/ProviderRegistration';
import ConfirmationStep from '../components/steps/ConfirmationStep';
import ProviderProfile from '../frontend/Provider/ProviderProfile';
const BusinessDetail = lazy(
  () => import('../frontend/Business/BusinessDetail')
);
const ProfileSettings = lazy(
  () => import('../frontend/Customer/ProfileSettings/ProfileSettings')
);
import TestImageLoading from '../../test-image-loading';
import BookingPage from '../frontend/Booking/BookingPage';
const BookingPayPage = lazy(() => import('../frontend/Booking/BookingPayPage'));
//import HowItWork from '../staticPages/HowItWork';
import JobRequestForm from '../frontend/Quote/JobRequestForm';
import BatchQuoteRequestForm from '../frontend/Quote/BatchQuoteRequestForm';
import PackageSelection from '../frontend/Package/PackageSelection';
import PackageCheckout from '../frontend/Package/PackageCheckout';
import CreditSession from '../frontend/Package/CreditSession';
import ComparePlans from '../staticPages/ComparePlans';
import SafetyInsurance from '../staticPages/SafetyInsurance';
import AboutHirePanther from '../staticPages/AboutHirePanther';
import Contact from '../staticPages/Contact';
//import ReportIssue from '../staticPages/ReportIssue';
import Accessibility from '../staticPages/Accessibility';
import TermsService from '../staticPages/TermsService';
import PrivacyPolicy from '../staticPages/PrivacyPolicy';
import CookiePolicy from '../staticPages/CookiePolicy';
import TaxPolicy from '../staticPages/TaxPolicy';
import DMCA from '../staticPages/DMCA';
import AdvertisingPolicy from '../staticPages/AdvertisingPolicy';
import Sitemap from '../staticPages/Sitemap';
import SupportTicketPage from '../frontend/SupportTicket/SupportTicketPage';
import ReferralPage from '../frontend/referral/ReferralPage';
const RecoverTwoFactor = lazy(
  () => import('../frontend/auth/RecoverTwoFactor')
);

const routes = all_routes;
const publicRoutes = [
  {
    path: routes.index,
    name: 'Home',
    element: <Home />,
    route: Route,
  },
  {
    path: routes.homePreview,
    name: 'Home Preview',
    element: <Navigate to="/home" replace />,
    route: Route,
  },
  {
    path: '/',
    name: 'Root',
    element: <Navigate to="/home" replace />,
    route: Route,
  },

  {
    path: routes.referral,
    name: 'Referral',
    element: <ReferralPage />,
    route: Route,
  },
  {
    path: routes.recoverTwoFactor,
    name: 'Recover Two Factor',
    element: <RecoverTwoFactor />,
    route: Route,
  },

  {
    path: routes.services,
    name: 'services',
    element: <Services />,
    route: Route,
  },
  {
    path: '*',
    name: 'NotFound',
    element: <Navigate to="/home" replace />,
    route: Route,
  },

  // pages module's path
  {
    path: routes.serviceBooking,
    name: 'Booking',
    element: <BookingPage />,
    route: Route,
    roles: ['customer', 'provider', 'admin'],
  },

  // Public pay page for provider-created bookings — no roles so the in-page
  // auth gate shows before any booking fetch (GET endpoints 401 anonymous).
  {
    path: routes.bookingPay,
    name: 'Booking Pay',
    element: <BookingPayPage />,
    route: Route,
  },

  // Phase 2 — Quote-based booking: Job Request Form
  {
    path: routes.serviceJobRequest,
    name: 'Job Request',
    element: <JobRequestForm />,
    route: Route,
    roles: ['customer', 'provider', 'admin'],
  },

  // Phase 2 — Quote-based booking: Batch Quote Request (multi-provider)
  {
    path: routes.serviceBroadcastRequest,
    name: 'Batch Quote Request',
    element: <BatchQuoteRequestForm />,
    route: Route,
    roles: ['customer', 'provider', 'admin'],
  },

  // Phase 3 — Package-based booking: Package Selection, Checkout, Credit Session
  {
    path: routes.servicePackage,
    name: 'Package Selection',
    element: <PackageSelection />,
    route: Route,
    roles: ['customer', 'provider', 'admin'],
  },
  {
    path: routes.servicePackageCheckout,
    name: 'Package Checkout',
    element: <PackageCheckout />,
    route: Route,
    roles: ['customer', 'provider', 'admin'],
  },
  {
    path: routes.serviceCreditSession,
    name: 'Credit Session',
    element: <CreditSession />,
    route: Route,
    roles: ['customer', 'provider', 'admin'],
  },

  {
    path: '/registration-provider',
    name: 'Provider Registration',
    element: <ProviderRegistration />,
    route: Route,
  },

  {
    path: '/booking/success',
    name: 'Booking Success',
    element: <ConfirmationStep />,
    route: Route,
    roles: ['customer', 'provider', 'admin'],
  },

  {
    path: routes.businessDetail,
    name: 'Business Detail',
    element: <BusinessDetail />,
    route: Route,
  },

  // Centralized Profile Settings — standalone page (no sidebar) shared across Customer & Provider portals
  {
    path: '/profile-settings',
    name: 'Profile Settings',
    element: <ProfileSettings />,
    route: Route,
    roles: ['customer', 'provider'],
  },

  {
    path: routes.providerProfile,
    name: 'Provider Profile',
    element: <ProviderProfile />,
    route: Route,
  },

  {
    path: '/test-image-loading',
    name: 'Test Image Loading',
    element: <TestImageLoading />,
    route: Route,
  },

  //contact us page
  {
    path: '/contact',
    name: 'Contact',
    element: <Contact />,
    route: Route,
  },

  //How it works page
  //{
  //path: '/how-it-works',
  //name: 'How It Works',
  //element: <HowItWork />,
  //route: Route,
  //},

  {
    path: routes.comparePlans,
    name: 'Compare Plans',
    element: <ComparePlans />,
    route: Route,
  },

  //Bookings help page
  // {
  //   path:'/bookings-help',
  //   name: 'Bookings Help',
  //   element: <BookingsHelp/>,
  //   route: Route,
  // },

  //Redeem voucher page
  // {
  //  path: '/redeem-voucher',
  //  name: 'Redeem Voucher',
  //  element: <RedeemVoucher/>,
  //  route: Route,
  // },

  //Referrals page
  // {
  //   path: '/referrals',
  //   name: 'Referrals',
  //   element: <Referrals/>,
  //   route: Route,
  //  },

  //Safety & Insurance page
  {
    path: '/safety-insurance',
    name: 'Safety & Insurance',
    element: <SafetyInsurance />,
    route: Route,
  },

  //Affiliate page
  //  {
  //   path: '/affiliate',
  //   name: 'Affiliate',
  //   element: <Affiliate/>,
  //   route: Route,
  //  },

  //About HirePanther page
  {
    path: '/about-hirepanther',
    name: 'About HirePanther',
    element: <AboutHirePanther />,
    route: Route,
  },

  //Careers page
  //   {
  //   path: '/careers',
  //   name: 'Careers',
  //   element: <Careers/>,
  //   route: Route,
  //  },

  //Press page
  //  {
  //   path: '/press',
  //   name: 'Press',
  //   element: <Press/>,
  //   route: Route,
  //  },

  //Report an issue page
  //{
  //  path: '/report-issue',
  //  name: 'Report Issue',
  //  element: <ReportIssue />,
  //  route: Route,
  // },

  //Accessibility page
  {
    path: '/accessibility',
    name: 'Accessibility',
    element: <Accessibility />,
    route: Route,
  },

  //Terms of Service page
  {
    path: '/terms-services',
    name: 'Terms of Service',
    element: <TermsService />,
    route: Route,
  },

  //Privacy Policy page
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    element: <PrivacyPolicy />,
    route: Route,
  },

  //Cookie Policy page
  {
    path: '/cookie-policy',
    name: 'Cookie Policy',
    element: <CookiePolicy />,
    route: Route,
  },
  //Tax Policy page
  {
    path: '/tax-policy',
    name: 'Tax Policy',
    element: <TaxPolicy />,
    route: Route,
  },

  //DMCA page
  {
    path: '/dmca',
    name: 'DMCA',
    element: <DMCA />,
    route: Route,
  },

  //Advertising Policy page
  {
    path: '/advertising-policy',
    name: 'Advertising Policy',
    element: <AdvertisingPolicy />,
    route: Route,
  },

  //Sitemap page
  {
    path: '/sitemap',
    name: 'Sitemap',
    element: <Sitemap />,
    route: Route,
  },

  {
    path: routes.supportTicket,
    name: 'Support Ticket',
    element: <SupportTicketPage />,
    route: Route,
  },

  // {
  //   path: routes.booking2,
  //   name: 'booking-2',
  //   element: <Booking2 />,
  //   route: Route,
  // },
  // {
  //   path: routes.bookingDone,
  //   name: 'booking-done',
  //   element: <BookingDone />,
  //   route: Route,
  // },
  // {
  //   path: routes.bookingPayment,
  //   name: 'booking-payment',
  //   element: <BookingPayment />,
  //   route: Route,
  // },

  // provider module's path

  // {
  //   path: routes.paymentSetting,
  //   name: 'payment-setting',
  //   element: <PaymentSetting />,
  //   route: Route,
  // },

  //customer module's path

  // blog module's path
  // service path

  // {
  //   path: routes.pages,
  //   name: 'pages',
  //   element: <Pages />,
  //   route: Route,
  // },
  // {
  //   path: routes.customers,
  //   name: 'customers',
  //   element: <Customers />,
  //   route: Route,
  // },

  // {
  //   path: routes.blog,
  //   name: 'blog',
  //   element: <Blog />,
  //   route: Route,
  // },
  // {
  //   path: routes.providers,
  //   name: 'providers',
  //   element: <Providers />,
  //   route: Route,
  // },

  // // Admin Module Path
  // {
  //   path: routes.admin,
  //   name: 'admin',
  //   element: <Admin />,
  //   route: Route,
  // },
  // {
  //   path: 'admin',
  //   name: 'Root',
  //   element: <Navigate to="/admin/dashboard" />,
  //   route: Route,
  // },
];

export const authRoutes = [
  // {
  //   path: '/authentication/reset-password',
  //   name: 'reset-password',
  //   element: <ResetPassword />,
  //   route: Route,
  // },
  // {
  //   path: routes.passwordRecovery,
  //   name: 'password-recovery',
  //   element: <PasswordRecovery />,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/login',
  //   name: 'login',
  //   element: <Login/>,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/login-phone1',
  //   name: 'login-phone1',
  //   element: <LoginPhone1/>,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/phone-otp',
  //   name: 'Phone-Otp',
  //   element: <PhoneOtp/>,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/email-otp',
  //   name: 'email-Otp',
  //   element: <EmailOtp/>,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/choose-signup',
  //   name: 'choose-signup',
  //   element: <ChooseSignup/>,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/user-signup',
  //   name: 'user-signup',
  //   element: <UserSignup />,
  //   route: Route,
  // },
  // {
  //   path: routes.providerSignup,
  //   name: 'Provider-signup',
  //   element: <ProviderRegister />,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/success',
  //   name: 'success',
  //   element: <Success />,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/free-trail',
  //   name: 'free-trial',
  //   element: <FreeTrail />,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/error-404',
  //   name: 'Error404',
  //   element: <Error404 />,
  //   route: Route,
  // },
  // {
  //   path: '/authentication/error-500',
  //   name: 'Error500',
  //   element: <Error500 />,
  //   route: Route,
  // },
];
export { publicRoutes };
